module.exports = __webpack_public_path__ + "step-rolling.e83efae05f7a1e2c1f4908d0e0331c83.hashedasset.svg";